import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import CurrencyFormat from "react-currency-format";
import { useDispatch, useSelector } from "react-redux";


// import components
import PortfolioPerformance from "../components/Hedging/PortfolioPerformance.js";
import PortfolioAllocation from "../components/Hedging/PortfolioAllocation.js";
import TradingViewWidget from "../components/Hedging/header.js"
import FooterNew from "../components/Footer-New";
import NavbarInner from "../components/Navbar-Inner.js";
import NavbarInnerSide from "../components/NavbarInnerSide.js";
import Sidebar from "../components/Sidebar.js";
import NewChart from "../components/Hedging/newChart.js"
import ListTable from "../components/Hedging/Table.js";

//lib
import { toFixedDown, truncateDecimals } from "../lib/roundOf";

//api
import { getPairList, setPairList } from "../api/tradeAction.js";




export default function Hedging(props) {

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);



  //hooks
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation()


  //redux
  const pairListData = useSelector((state) => state.pairList);
  // const { userDashboard } = useSelector((state) => state.siteSetting)

  //state
  const [symbols, setSymbols] = useState([])
  const [duppairlists, setduppairlists] = useState([]);
  const [piechart, setPieChart] = useState([])
  const [available, setAvailable] = useState(0);
  const [piecurrency, setPieCurrency] = useState([])


  //function
  const fetchPairList = async () => {
    try {
      const { status, result } = await getPairList();
      if (status == "success") {
        setPairList(result, dispatch);
      }
    } catch (err) {
      console.log(err, "error");
    }

  };




  useEffect(() => {
    fetchPairList();
  }, [])

  useEffect(() => {
    if (pairListData && pairListData.length > 0) {
      let array = []
      let curArray = []
      var newarray = [];
      let symbol = []
      let totalAmount = 0;

      for (var i = 0; i < pairListData.length; i++) {
        if (pairListData[i].hedging == true && pairListData[i].hedgeStatus == "active") {
          // console.log(pairListData[i], "-pairListData[i]")
          newarray.push(pairListData[i]);
          if (pairListData[i].type == 'crypto') {
            symbol.push({ proName: "BINANCE:" + pairListData[i].firstCurrencySymbol + pairListData[i].secondCurrencySymbol })
          }
          // let color = userDashboard && userDashboard.length > 0 && userDashboard.find((el) => el.currencyId == pairListData[i].firstCurrencyId || el.currencyId == pairListData[i].secondCurrencyId)

          curArray.push({
            currency: pairListData[i].firstCurrencySymbol,
            // colorCode: color != undefined ? color.colorCode : "",
            _id: pairListData[i]._id,
            image: pairListData[i].image,
          })
          array.push(parseFloat(pairListData[i].hedgeQty) * parseFloat(pairListData[i].markPrice))
          totalAmount += parseFloat(pairListData[i].hedgeQty) * parseFloat(pairListData[i].markPrice)
        }
      }
      setSymbols(symbol)
      setAvailable(toFixedDown(totalAmount, 2))
      setPieChart(array)
      setPieCurrency(curArray)
      setduppairlists(newarray);
    }
  }, [pairListData]);





  return (
    <div>
    
      {/* <NavbarInner /> */}
      <NavbarInnerSide toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      <div className="flex w-full relative">
        <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)} />
        <div className="flex-1 w-full overflow-hidden p-4">
          <div className="">
            <div className="row">
              <div className="col-lg-12">
                <div className="">
                  <TradingViewWidget symbols={symbols} />
                </div>
                <div className=" bg-[#ACC6B8]/20 rounded-sm p-2 flex justify-center gap-2 mt-4">
                  <h3 className="text-[14px] text-[#6b7280]">{t("TOTAL_HEDGE_FUND")}: </h3>
                  <h3 style={{ color: available >= 0 ? "#395645" : "#dc3545" }} className="text-[14px] font-semibold">
                    ${" "}
                    <CurrencyFormat
                      displayType={"text"}
                      thousandSeparator={true}
                      value={available}
                    />
                  </h3>
                </div>
                <div className="row">
                  <div className="col-lg-6 d-flex">
                    <div className=" w-100 rounded-[4px] p-4 border border-[#6B7280]/25 mt-4">
                      <div className="mb-4">
                        <h6 className="text-[15px] font-semibold text-[#395645]">{t("PORTFOLIO_PERFORMANCE")}</h6>
                      </div>

                      <NewChart piecurrency={piecurrency} />
                      {/* <PortfolioPerformance /> */}
                    </div>
                  </div>
                  <div className="col-lg-6 d-flex">
                    <div className=" w-100 rounded-[4px] p-4 border border-[#6B7280]/25 mt-4">
                      <div className="mb-4">
                        <h6 className="text-[15px] font-semibold text-[#395645]">{t('PORTFOLIO_ALLOCATION')}</h6>
                      </div>
                      <PortfolioAllocation piechart={piechart} piecurrency={piecurrency} />
                    </div>
                  </div>
                </div>
                <div className="rounded-sm outline outline-1 outline-offset-[-1px] outline-[#6B7280]/25 mt-4">
                  <div className="primary_datatable">
                    <ListTable duppairlists={duppairlists} setduppairlists={setduppairlists} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <FooterNew/> */}
    </div>
  );
}
